// extracted by mini-css-extract-plugin
module.exports = {"main_wrap":"projectviewer_main_wrap__2_oWi","update_button_wrap":"projectviewer_update_button_wrap__1yGlR","projects_button_wrap":"projectviewer_projects_button_wrap__21KHf"};